import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useApp } from "@/context/AppContext";
import { ReminderForm } from "@/components/forms/ReminderForm";
import { ProjectForm } from "@/components/forms/ProjectForm";
import { NoteForm } from "@/components/forms/NoteForm";

const LABELS = { reminder: "Reminder", project: "Project", note: "Note", thought: "Thought" };
const HINTS = {
  reminder: "Type it, pick a priority, done. Emails the owner + support 9am–5pm until ticked off.",
  project: "Something that takes days. Add reminders and notes inside it.",
  note: "Just a note. No emails.",
  thought: "Log something to bring up with the team.",
};

export const QuickAddDialog = () => {
  const { dialog, setDialog, closeDialog } = useApp();
  const open = !!dialog;
  const type = dialog?.type || "reminder";
  const editing = !!dialog?.item;
  const props = { item: dialog?.item, defaults: dialog?.defaults || {}, onDone: closeDialog };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && closeDialog()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto border-white/10 bg-card/95 backdrop-blur-xl sm:max-w-[560px]" data-testid="quick-add-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold tracking-tight">{editing ? `Edit ${LABELS[type].toLowerCase()}` : `New ${LABELS[type].toLowerCase()}`}</DialogTitle>
          <DialogDescription>{HINTS[type]}</DialogDescription>
        </DialogHeader>
        {!editing && (
          <Tabs value={type} onValueChange={(t) => setDialog({ ...dialog, type: t })}>
            <TabsList className="grid w-full grid-cols-4">
              {Object.entries(LABELS).map(([k, l]) => (
                <TabsTrigger key={k} value={k} data-testid={`quick-add-tab-${k}`}>{l}</TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        )}
        {open && type === "reminder" && <ReminderForm key={`r-${dialog?.item?.id}`} {...props} />}
        {open && type === "project" && <ProjectForm key={`p-${dialog?.item?.id}`} {...props} />}
        {open && (type === "note" || type === "thought") && <NoteForm key={`n-${type}-${dialog?.item?.id}`} kind={type} {...props} />}
      </DialogContent>
    </Dialog>
  );
};
